/* ===========================================================================
   c-lp-cart.js — AJAX add to cart for landing-page product forms
   ===========================================================================

   Progressive enhancement only. Every add-to-cart control on a c-lp-* section
   is a real Shopify product form (`{% form 'product', product, data-atc: 'true' %}`)
   that posts to /cart/add, so without JavaScript (and for visitors whose JS is
   blocked by the store's Linux cloak script) the button still works and lands
   on /cart.

   With JavaScript the submit is intercepted, the variant is added through
   /cart/add.js, and the theme's own cart drawer is refreshed and opened with
   the documented Symmetry events (`dispatch:cart-drawer:refresh` / `:open`,
   same pattern as sections/c-home-products.liquid).

   The guard name is shared with c-home-products on purpose: if both ever land
   on one page, only one listener is bound and a product is never added twice.

   Load from a section with:
     <script src="{{ 'c-lp-cart.js' | asset_url }}" defer></script>
   =========================================================================== */
(function () {
  if (window.__cAtcBound) return;
  window.__cAtcBound = true;

  document.addEventListener('submit', function (event) {
    var form = event.target.closest && event.target.closest('form[data-atc]');
    if (!form) return;
    event.preventDefault();

    var button = form.querySelector('[type="submit"]');
    var label = button ? button.innerHTML : '';
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Adding…';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (response) {
        return response.ok ? response.json() : Promise.reject(response);
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
        // No drawer mounted on this page: the button still has to do something.
        if (!document.querySelector('cart-drawer')) window.location.href = '/cart';
      })
      .catch(function () {
        form.submit(); // last resort: the plain POST
      })
      .finally(function () {
        if (button) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.innerHTML = label;
        }
      });
  });
})();
